export const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}
